














import Vue, { PropType } from 'vue'
import Channel from '@/types/Channel.interface'
import User from '@/types/User.interface'
export default Vue.extend({
    name: 'TypingIndicator',
    props: {
        //  The message channel the indicator will subscribe to
        channel: {
            type: Object as PropType<Channel>,
            default: null
        },
        //  Indicates if the user is typing or not
        typing: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            //  The name of the whisper channel the component is subscribed to
            subscribedChannelName: null,

            // The array containing users who are currently typing
            usersTyping: []
        }
    },
    computed: {
        text(): string {
            // Get the number of users typing
            const numOfUsersTyping = this.usersTyping.length

            // If no users are typing, return the empty string
            if (!numOfUsersTyping) return ''

            // Return the users who are typing
            return (
                this.usersTyping.join(', ') +
                ` ${numOfUsersTyping === 1 ? 'is' : 'are'} typing`
            )
        },
        user(): User {
            return this.$store.getters.user
        }
    },
    methods: {
        //  The callback for the websocket event 'typing'
        pushUserTyping(userFullNameOrEmail: string): void {
            //  Search for an existing user
            const exists = this.usersTyping.find((x) => x == userFullNameOrEmail)

            //  If the user is already in the array, do nothing
            if (exists) return

            //  Else, add the user to the array
            this.usersTyping.push(userFullNameOrEmail)
        },
        //  The callback for the websocket event 'notTyping'
        popUserTyping(userFullNameOrEmail: string): void {
            //  Find the index of the user name we are removing
            const i = this.usersTyping.indexOf(userFullNameOrEmail)

            //  If the user was NOT found, do nothing
            if (i === -1) return

            //  Else, remove the name from the usersTyping list
            this.usersTyping.splice(i, 1)
        },
        //  Subscribes to the whisper channel bound to the current 'channelId'
        subscribe(channel: Channel): void {
            //  Assemble the new whisper channel name
            const name = `channel-${this.$store.getters.tenant.id}-${channel.id}-typing`

            //  Check if we are subscribed to a channel
            const subscribed = this.subscribedChannelName

            //  Check if we are already subscribed to correct channel
            const alreadySubscribed = subscribed && name == this.subscribedChannelName

            //  If we are already subscribed, do nothing
            if (alreadySubscribed) return

            //  Else, if we are subscribed to the wrong channel, we need to leave it
            if (subscribed) window.Echo.leave(this.subscribedChannelName)

            //  Now, update the subscribed channel to the new name (for reference)
            this.subscribedChannelName = name
            //  Subscribe to the new whisper channel (we bind callbacks to the event name)
            window.Echo.join(name)
                .listenForWhisper('typing', this.pushUserTyping)
                .listenForWhisper('notTyping', this.popUserTyping)
        },
        //  Unsubscribe from the current whisper channel (if it exists)
        unsubscribe(): void {
            //  If we are NOT subscribed to a channel, do nothing
            if (!this.subscribedChannelName) return

            //  Else, leave the whisper channel
            window.Echo.leave(this.subscribedChannelName)

            //  Set the subscribed channel name to null
            this.subscribedChannelName = null
        }
    },
    watch: {
        channel(channel: Channel) {
            //  If the channel is null, unsubscribe from any existing whisper channels
            if (!channel) return this.unsubscribe()

            //  Else, Subscribe to the new whisper channel
            this.subscribe(channel)
        },
        typing(typing) {
            //  If we are NOT subscribed to a whisper channel, do nothing
            if (!this.subscribedChannelName) return

            //  Else, get the current whisper channel
            const typingChannel = window.Echo.private(this.subscribedChannelName)

            //  Get the username for the currently authenticated user
            const userName = this.$options.filters.userFullNameOrEmail(this.user)

            // If the user is typing, tell other clients that the user is typing
            if (typing === true) typingChannel.whisper('typing', userName)
            // Else, tell other clients that the user is no longer typing
            else typingChannel.whisper('notTyping', userName)
        }
    }
})
